import { Injectable } from '@angular/core';

export class DropDown {
  religions: [];
  bloodGroup: [];
  organisation: [];
  reportingTo: []
  location: [];
  department: [];
  designation: [];
  bbReason: [];
  bbCrash: [];
  gender: [];
  startTime: [];
  married: [];
  operatingSystem: [];
  projectPlatforms: [];
  currencySet: [];
  gitStatus: [];
  currentStatus: [];
  projectType: [];
  popupStatus: [];
  resourceType: [];
  systemType: [];
  resourceRole: [];
  screenshotsTiming: [];
}

@Injectable({
  providedIn: 'root'
})

export class GetOperations {

  profileDropDown = new DropDown();

  getProfileDropDown(dropdownresults) {

    this.profileDropDown.religions = dropdownresults.get('religions');
    this.profileDropDown.bloodGroup = dropdownresults.get('bloodGroup');
    this.profileDropDown.organisation = dropdownresults.get('organisation');
    this.profileDropDown.reportingTo = dropdownresults.get('reportingTo');
    this.profileDropDown.location = dropdownresults.get('location');
    this.profileDropDown.department = dropdownresults.get('department');
    this.profileDropDown.designation = dropdownresults.get('designation');
    this.profileDropDown.bbReason = dropdownresults.get('bbReason');
    this.profileDropDown.bbCrash = dropdownresults.get('bbCrash');
    this.profileDropDown.gender = dropdownresults.get('gender');
    this.profileDropDown.married = dropdownresults.get('married');
    this.profileDropDown.startTime = dropdownresults.get('startTime');
    this.profileDropDown.operatingSystem = dropdownresults.get('operatingSystem');
    this.profileDropDown.projectPlatforms = dropdownresults.get('projectPlatforms');
    this.profileDropDown.currencySet = dropdownresults.get('currencySet');
    this.profileDropDown.gitStatus = dropdownresults.get('gitStatus');
    this.profileDropDown.currentStatus = dropdownresults.get('currentStatus');
    this.profileDropDown.projectType = dropdownresults.get('projectType');
    this.profileDropDown.popupStatus = dropdownresults.get('popupStatus');
    this.profileDropDown.resourceType = dropdownresults.get('resourceType');
    this.profileDropDown.systemType = dropdownresults.get('systemType');
    this.profileDropDown.resourceRole = dropdownresults.get('resourceRole');
    this.profileDropDown.screenshotsTiming = dropdownresults.get('screenshotsTiming');

    return this.profileDropDown;
  }

}
